export interface LegacyBranchOffice {
  id: string
  typeCode: 1 | 2 | 3
  typeName: '직영점' | '체인점' | '본사'
  name: string
  zonecode: string
  address: string
  addressDetail: string
  buildingCode: string
}

export const legacyBranchOffices: LegacyBranchOffice[] = Array.from({ length: 30 }, (_, index) => {
  const typeCode: 1 | 2 | 3 = index >= 28 ? 3 : index % 3 === 0 ? 2 : 1
  return {
    id: `${index + 1}`,
    typeCode,
    typeName: typeCode === 1 ? '직영점' : typeCode === 2 ? '체인점' : '본사',
    name: `모의지점 ${String(index + 1).padStart(2, '0')}`,
    zonecode: `0${String(1000 + index).padStart(4, '0')}`,
    address: `모의시 테스트로 ${index + 1}`,
    addressDetail: `${index + 1}층`,
    buildingCode: `MOCK-${String(index + 1).padStart(3, '0')}`,
  }
})
